const required = (name: string, value: string | undefined): string => {
  if (!value) {
    // eslint-disable-next-line no-console
    console.warn(`[env] Missing ${name} — some features will be disabled.`);
    return '';
  }
  return value;
};

export const OWNER_EMAIL = 'dhanushkarthik8@gmail.com';

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000',
  devBypassAuth: import.meta.env.VITE_DEV_BYPASS_AUTH === 'true',
} as const;
